import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../../../../../media';

export const FilterModalWrapper = styled.div`
	padding: 31px 54px 40px;
	${media.mobile} {
		padding: 10px 16px;
	}
`;

export const FilterListWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 288px);
	height: 100%;
	column-gap: 48px;
	row-gap: 18px;
	${media.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const FilterListStyle = css`
	align-content: start;
	grid-auto-rows: auto;
	row-gap: 26px;
`;

export const FilterBtnWrapper = css`
	display: grid !important;
	grid-template-columns: auto 149px;
	min-height: max-content;
	column-gap: 11px !important;
	${media.mobile} {
		grid-template-columns: auto 48px;
		padding: 24px 16px 16px !important;
	}

	& svg {
		fill: var(--text-primary);
	}
`;

export const ResetButtonStyles = css`
	& > span {
		display: grid;
		grid-template-columns: 24px 73px;
		margin: 0 auto;
		column-gap: 4px;

		${media.mobile} {
			grid-template-columns: max-content;
			column-gap: 0;
		}
	}

	${media.mobile} {
		padding: 10px 0 !important;
	}
`;

export const HeaderStyles = css`
	padding: 26px 54px;
	& > h3 {
		padding: 0 !important;
		text-align: left !important;
	}

	${media.mobile} {
		padding: 15px 16px 13px;
	}
`;

// !important для перекрытия стилей фронтона
